module.exports = __webpack_public_path__ + "static/media/RD_LL_BONNIE.675c5c4c.webp";